import {
  Show,
  createEffect,
  createMemo,
  createSignal,
  onCleanup,
  onMount,
} from "solid-js";

import { getUserInfoDetails } from "@/api/clientApi/user";
import { Button } from "@/components/Base/Button/Button";
import LazyImg from "@/components/Base/LazyImg";
import Icon from "@/components/Icon";
import { useRouter } from "@/hooks/useRouter";
import { t } from "@/i18n";
import { pubSub } from "@/lib/PubSub";
import { getImgurl } from "@/lib/resFolder";
import { isLogin, userStore } from "@/stores/userStore";
import { PubSubEvents } from "@/types/PubSub";
import { GetUserInfoDetailsRsp } from "@/types/swagger/front";

export default function VerifyTip() {
  const [isNeedVerify, setIsNeedVerify] = createSignal(false);
  const { push } = useRouter();
  // 创建响应式的 userInfo 值
  const userInfo = createMemo(() => userStore.userInfo);
  const isLogin = createMemo(() => userStore.isLogin);
  const [info, setInfo] = createSignal<GetUserInfoDetailsRsp | null>(null);

  createEffect(() => {
    if (isLogin()) {
      updateInfo();
    }
  });
  const updateStatus = (val: boolean) => {
    if (val) {
      setIsNeedVerify(false);
    } else {
      const shouldVerify =
        !!userStore.userInfo?.is_pay &&
        !userStore.userInfo?.phone &&
        !userStore.userInfo?.email;
      setIsNeedVerify(shouldVerify);
    }
  };

  const updateInfo = () => {
    (async () => {
      const res = await getUserInfoDetails();
      setInfo(res as GetUserInfoDetailsRsp);
    })();
  };

  onMount(() => {
    pubSub.subscribe(PubSubEvents.UserInfoUpdated, updateStatus);
    const shouldVerify =
      !!userStore.isLogin &&
      !!userStore.userInfo?.is_pay &&
      !userStore.userInfo?.phone &&
      !userStore.userInfo?.email &&
      !info()?.verify?.personal_info?.contact_email &&
      !info()?.verify?.personal_info?.contact_phone;
    setIsNeedVerify(shouldVerify);
    onCleanup(() => {
      pubSub.unsubscribe(PubSubEvents.UserInfoUpdated, updateStatus);
    });
  });
  const handleVerify = () => {
    push("/settings?tab=security");
  };

  return (
    <Show when={isNeedVerify()} fallback={<></>}>
      <div class="bg-general-bg2 fixed bottom-[76px] left-0 right-0 z-[400] mx-[12px] flex h-[73px] items-center gap-x-[8px] rounded-[10px] px-[12px]">
        <LazyImg
          src={getImgurl("setting.png", "common/home")}
          class="h-[40px] w-[40px]"
        />
        <Icon
          name="general/xx2"
          class="absoluteh-[10px] w-[10px]"
          wrapperClass="absolute right-[8px] top-[6px] h-[6px] w-[10px"
          onClick={() => setIsNeedVerify(false)}
        />
        <div class="text-general-bright flex-1 break-normal text-[12px] font-[500]">
          {t("home.verify_notice")}
        </div>
        <div>
          <Button
            variant="primary"
            type="button"
            class="text-general-butzi h-[30px] w-[58px] text-[12px] font-bold"
            onClick={() => handleVerify()}
          >
            {t("settings.verify")}
          </Button>
        </div>
      </div>
    </Show>
  );
}
